<template>
    <transition-group
        tag="div"
        name="bounce"
        class="toast-container"
    >
        <ToastElement
            v-for="toast in toasts"
            :key="toast.id"
            v-bind="toast"
            @close="removeToast"
        />
    </transition-group>
</template>

<script>
import {defineComponent, computed} from 'vue';
import {useToastsStore} from '@/stores/toasts';

export default defineComponent({
    name: 'ToastContainer',
    components: {
        ToastElement: () => import('@/components/Toast/ToastElement.vue'),
    },
    setup() {
        const toastsStore = useToastsStore();
        const toasts = computed(() => toastsStore.toasts);
        const {removeToast} = toastsStore;

        return {
            toasts,
            removeToast,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/common/toasts';
</style>
